/* Peculiar People size charts (22 Oct 2026, replaces the Kiwi Size Chart app). Any
   button with data-pp-size-chart="<garment>" opens that garment's chart from the JSON in
   snippets/pp-size-charts.liquid: the link under the price, and the pair bundle's buttons
   for both of its items (snippets/pp-size-button.liquid). Without this script or the data, html never gets
   .pp-size-ready and pp-size.css keeps every link hidden. */
(function () {
  if (window.ppSizeChart) return;

  function charts() {
    var el = document.querySelector('script[data-pp-size-charts]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // The garment of a product from its tags (as Kiwi matched) or its type. Used by
  // pp-bundle.js for the item it adds.
  function garmentOf(type, tags) {
    var t = (tags || []).join(',');
    if (/apparel:tee\b/.test(t)) return 'tee';
    if (/apparel:hoodie\b/.test(t)) return 'hoodie';
    if (/apparel:crew\b/.test(t)) return 'sweatshirt';
    if (/apparel:bomber\b/.test(t)) return 'jacket';
    if (/sweatshirt/i.test(type)) return 'sweatshirt';
    if (/hoodie/i.test(type)) return 'hoodie';
    if (/tee|t-shirt/i.test(type)) return 'tee';
    if (/jacket/i.test(type)) return 'jacket';
    return null;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }

  var dialog = null;
  function getDialog() {
    if (dialog) return dialog;
    var d = document.createElement('dialog');
    d.className = 'pp-size';
    d.setAttribute('aria-labelledby', 'pp-size-title');
    d.innerHTML = '<div class="pp-size__head"><p class="pp-size__title" id="pp-size-title"></p>' +
      '<button type="button" class="pp-size__close" aria-label="Close">' +
      '<svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="pp-size__body"></div>';
    d.querySelector('.pp-size__close').addEventListener('click', function () { d.close(); });
    // A tap on the backdrop (outside the panel) closes it.
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('pp-size-open');
      if (d._opener && d._opener.isConnected) d._opener.focus();
    });
    document.body.appendChild(d);
    dialog = d;
    return d;
  }

  function fill(body, c) {
    body.innerHTML = '';
    var wrap = el('div', 'pp-size__scroll');
    var table = el('table', 'pp-size__table');
    var head = table.appendChild(el('thead'));
    var rows = table.appendChild(el('tbody'));
    c.rows.forEach(function (row, r) {
      var tr = el('tr');
      row.forEach(function (cell, i) {
        var th = r === 0 || i === 0;
        var td = el(th ? 'th' : 'td', '', cell);
        if (th) td.scope = r === 0 ? 'col' : 'row';
        tr.appendChild(td);
      });
      (r === 0 ? head : rows).appendChild(tr);
    });
    wrap.appendChild(table);
    body.appendChild(wrap);
    body.appendChild(el('p', 'pp-size__unit', 'Measurements in inches, garment laid flat.'));
    if (c.note) body.appendChild(el('p', 'pp-size__note', c.note));
    if (c.img) {
      var img = el('img', 'pp-size__img');
      img.src = c.img;
      img.alt = 'How to measure: length, shoulder, chest and sleeve length';
      img.width = 1080;
      img.height = 540;
      body.appendChild(img);
    }
  }

  function open(garment, opener) {
    var all = charts();
    var c = all && all[garment];
    if (!c) return false;
    var d = getDialog();
    d.querySelector('.pp-size__title').textContent = c.title;
    fill(d.querySelector('.pp-size__body'), c);
    d._opener = opener || null;
    if (!d.open) {
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
      document.documentElement.classList.add('pp-size-open');
    }
    d.querySelector('.pp-size__body').scrollTop = 0;
    d.scrollTop = 0;
    return true;
  }

  // Titles each button that has a label ("Hoodie size chart") from its chart, and hides
  // one whose garment has no chart.
  function paint(root) {
    var all = charts() || {};
    (root || document).querySelectorAll('[data-pp-size-chart]').forEach(function (b) {
      var c = all[b.dataset.ppSizeChart];
      var label = b.querySelector('[data-pp-size-label]');
      if (label && c) label.textContent = c.title;
      b.hidden = !c;
    });
  }

  window.ppSizeChart = { open: open, garmentOf: garmentOf, paint: paint };

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-pp-size-chart]');
    if (!b || !b.dataset.ppSizeChart) return;
    e.preventDefault();
    open(b.dataset.ppSizeChart, b);
  });

  function ready() {
    if (!charts()) return;
    paint();
    document.documentElement.classList.add('pp-size-ready');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
